// Countdown timer — counts to June 15, 2026 11:59 PM (CT) for standard shipping
  // After that date passes, switches to June 17, 2026 11:59 PM for expedited
  function updateCountdown() {
    const now = new Date().getTime();
    const standardDeadline = new Date('2026-06-15T23:59:59-05:00').getTime();
    const expeditedDeadline = new Date('2026-06-17T23:59:59-05:00').getTime();
    const fathersDayDate = new Date('2026-06-21T00:00:00-05:00').getTime();

    let targetDate;
    let isExpedited = false;
    let isPastShipping = false;

    if (now < standardDeadline) {
      targetDate = standardDeadline;
    } else if (now < expeditedDeadline) {
      targetDate = expeditedDeadline;
      isExpedited = true;
    } else {
      isPastShipping = true;
    }

    if (isPastShipping) {
      // Father's Day has passed or shipping window closed
      document.getElementById('cd-days').textContent = '0';
      document.getElementById('cd-hours').textContent = '0';
      document.getElementById('cd-minutes').textContent = '0';
      document.getElementById('cd-seconds').textContent = '0';
      document.getElementById('countdown-sub').textContent = 'Shipping window for Father\'s Day has closed. Still shop — we ship fast.';
      document.getElementById('topbar-message').innerHTML = '<strong>The Weekender Available Now</strong> · Same cotton he\'ll never want to take off';
      // Hide the hero mini countdown when window has closed
      const heroMiniCd = document.getElementById('hero-mini-cd');
      if (heroMiniCd) heroMiniCd.style.display = 'none';
      return;
    }

    const distance = targetDate - now;
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById('cd-days').textContent = days;
    document.getElementById('cd-hours').textContent = hours;
    document.getElementById('cd-minutes').textContent = minutes;
    document.getElementById('cd-seconds').textContent = seconds;

    // Hero mini countdown
    document.getElementById('mini-cd-days').textContent = days;
    document.getElementById('mini-cd-hours').textContent = hours;
    document.getElementById('mini-cd-minutes').textContent = minutes;
    document.getElementById('mini-cd-seconds').textContent = seconds;

    if (isExpedited) {
      document.getElementById('countdown-sub').textContent = 'Standard shipping window closed. Expedited shipping available for Father\'s Day delivery.';
      document.getElementById('topbar-message').innerHTML = '<strong>Order by June 17</strong> for expedited shipping <em>·</em> Standard window closed';
      // Update hero mini countdown label when standard window closes
      const heroMiniLabel = document.querySelector('#hero-mini-cd .label');
      if (heroMiniLabel) heroMiniLabel.textContent = 'Expedited shipping closes in';
    }
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

